import { sortBy } from "lodash";
export function reorderMenu(menuData) {
  menuData.items = reorderMenuItems(menuData.items);
}
function reorderMenuItems(list) {
  return sortMenuItems(list).map(item => ({
    ...item,
    children: reorderMenuItems(item.children)
  }));
}
function sortMenuItems(list) {
  return sortBy(list, item => {
    var _item$sort;
    return (_item$sort = item.sort) !== null && _item$sort !== void 0 ? _item$sort : -Infinity;
  });
}
//# sourceMappingURL=reorderMenuItems.js.map